import { html, css } from 'lit-element';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import { TmnButtonListToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';
import '../routing/routed-button';
import '../routing/routed-link';

class NavigationMenuMobile extends TmnButtonListToolBase {
    constructor() {
        super();
    }

    static get properties() {
        return {
            routes: {
                type: Array,
            },
            route: {
                type: String,
            },
        };
    }

    static get styles() {
        return [
            super.styles,
            css`
                :host {
                    --tmn-icon-font-size: 20px;
                    display: flex;
                    align-items: center;
                    text-wrap: nowrap;
                }
                tmn-modal {
                    color: var(--app-on-surface-color);
                    top: 90%;
                    left: unset;
                    right: 0;
                    min-width: 120px;
                }
                a {
                    user-select: none;
                    color: inherit;
                    text-decoration: none;
                }
            `,
        ];
    }
    // maybe this should be part of the selctor?
    getRoutesWithSelected() {
        const { routes } = this;
        const pathLowerCase = window.location.pathname?.toLowerCase() || '';
        const selectedName = pathLowerCase.includes('/sites')
            ? 'site-list'
            : pathLowerCase.includes('/video-service')
            ? 'video-service-list'
            : null;
        return routes.map((r, idx) => {
            return {
                ...r,
                selected: selectedName ? r.name === selectedName : idx === 0,
            };
        });
    }

    renderButton() {
        const modRoutes = this.getRoutesWithSelected();
        if (modRoutes.length === 0) {
            return null;
        }
        if (modRoutes.length === 1) {
            return this.renderRoutedButton(modRoutes[0]);
        }
        const selectedRoute = modRoutes.filter((r) => r.selected)[0];
        return html`${this.renderRoutedLink(selectedRoute)}
            <tmn-icon-button @click=${this._toggleDialog}>
                <tmn-icon icon="arrow_drop_down"></tmn-icon>
            </tmn-icon-button> `;
    }

    renderButtonList() {
        const modRoutes = this.getRoutesWithSelected();
        const displayRoutes = modRoutes.filter((r) => !r.selected);
        return displayRoutes.map((routeData) => this.renderRoutedButton(routeData));
    }

    renderRoutedButton(routeData) {
        const { name, data, displayKey } = routeData;
        return html`<routed-button
            variant="text"
            name=${name}
            .data=${data}
            @tmn-routed-item-click=${this._toggleDialog}>
            ${displayKey}
        </routed-button>`;
    }
    renderRoutedLink(routeData) {
        const { name, data, displayKey } = routeData;
        return html`<routed-link name=${name} .data=${data}> ${displayKey}</routed-link>`;
    }
}

window.customElements.define('navigation-menu-mobile', NavigationMenuMobile);
